let url = () =>{
    let url
    if(process.env.NODE_ENV === 'development') {
        url = `https://staging.afcfta.app`
    } else {
        // url = `http://139.162.234.164:81`
        url = `https://staging.afcfta.app`
        //url = `https://main.afcfta.app`
        // = `api.fiscoins.com/api/
    }
    return url
}

export default url;